<template>
    <div class="live">
        <div class="list">
            <div class="item" v-for="item in list" :key="item.id" @click="golive(item)">
                <div class="kv">
                    <img :src="item.cover_img" />
                    <div class="tag" :style="{background: item.color}">{{item.statename}}</div>
                </div>
                
                <div class="con">
                    <div class="title">{{item.title}}</div>
                    <div>{{item.anchor_name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { List } from 'vant';

export default {
    data() {
        return {
            list: []
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        init() {
            let query = {
               activity_sub_id: this.$route.params.subid 
            }
            this.$api.system.getLive(query).then(res=>{
                this.list = res.data
            })
        },
        golive(item) {
            if(item.appid == 'wx49c5d4bcc0a57700') {
                wx.miniProgram.navigateTo({
                    url: `plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${item.room_id}`,
                });
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>